export const onLoginView = () => ({
  type: 'Login Page View',
});
